import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { AccessControlService } from './access-control.service';

function resolveAccess(relation: string, objectType: string | null, objectId: string | null): Observable<boolean | UrlTree> {
  const accessControlService = inject(AccessControlService);
  const router = inject(Router);
  if (!objectId || !objectType) {
    // nothing to check yet (eg an 'add' route with no id)
    return of(true);
  }
  return accessControlService.checkPermissions(relation, objectType, objectId).pipe(
    map(allowed => allowed ? true : router.createUrlTree(['/restricted'])),
    catchError(() => of(router.createUrlTree(['/restricted'])))
  );
}

export const canEditGuard: CanActivateFn = (route) =>
  resolveAccess('can_edit', route.data['objectType'] as string, route.paramMap.get('id'));

export const canViewGuard: CanActivateFn = (route) => {
  // The detail view route is shared across multiple object types
  // Only enforce for protected entities so other reports keep their current behavior.
  const objectType = route.paramMap.get('type');
  if (objectType !== 'study' && objectType !== 'protocol') {
    return of(true);
  }
  return resolveAccess('can_view', objectType, route.paramMap.get('id'));
};
